import { render, staticRenderFns } from "./activities-list.vue?vue&type=template&id=aadd9b42"
import script from "./activities-list.vue?vue&type=script&lang=js"
export * from "./activities-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports